var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20.3815 17.4172C21.2018 18.2374 21.2018 19.5662 20.3815 20.3865C19.9747 20.7966 19.4366 21 18.8985 21C18.3604 21 17.8237 20.7949 17.4142 20.3848L10.4992 13.4734L3.58481 20.3832C3.17469 20.7966 2.63726 21 2.09984 21C1.56241 21 1.02564 20.7966 0.615186 20.3832C-0.205062 19.5629 -0.205062 18.2341 0.615186 17.4139L7.53152 10.4975L0.615186 3.58449C-0.205062 2.76424 -0.205062 1.43543 0.615186 0.615186C1.43543 -0.205062 2.76424 -0.205062 3.58449 0.615186L10.4992 7.5348L17.4155 0.618468C18.2358 -0.201781 19.5646 -0.201781 20.3848 0.618468C21.2051 1.43872 21.2051 2.76752 20.3848 3.58777L13.4685 10.5041L20.3815 17.4172Z","fill":"#E70000"}));
}

Close.defaultProps = {"width":"15","height":"15","viewBox":"0 0 21 21","fill":"none"};

module.exports = Close;

Close.default = Close;
